import { render } from "./PatientSummaryModal.vue?vue&type=template&id=23d512fc"
import script from "./PatientSummaryModal.vue?vue&type=script&lang=js"
export * from "./PatientSummaryModal.vue?vue&type=script&lang=js"

import "./PatientSummaryModal.vue?vue&type=style&index=0&id=23d512fc&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__